<template>
  <div>
    <router-btn :text="$t('servicesystem.common_objects.machine.change_owner_all_btn')" :icon="'mdi-swap-horizontal'"
      :color="'secondary'" :disabled="false" :outlined="true" :textbtn="textbtn" :large="large" :small="small"
      @Press="action">
    </router-btn>
    <TransferAllMachinesDialog :externaltrigger="dialogtrigger" :currentCustomerId="customerId" :allMachines="true"
      :saveFunction="transferAllMachines">
    </TransferAllMachinesDialog>
  </div>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import TransferAllMachinesDialog from "@/components/Dialogs/TransferMachinesDialog.vue";

export default {
  name: "TransferAllMachinesBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
    TransferAllMachinesDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 1,
    };
  },

  methods: {
    action() {
      this.dialogtrigger++;
    },

    async transferAllMachines(oldCustomerId, newCustomerId) {
      await clientAPI.methods.changeOwnerAllMachines(oldCustomerId, newCustomerId);
      this.$router.push({ query: { ...this.$route.query, timestamp: this.getNowTime(this.oldTimeFormat) } });
    },
  },

  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
